import NavAccount from "@gaiaProfessionals/Components/HCP/NavAccount";
import NavLinkList from "@gaiaProfessionals/Components/HCP/NavLinkList";
import NavSignIn from "@gaiaProfessionals/Components/HCP/NavSignIn";
import NavigationDrawer from "@gaiaProfessionals/Overrides/Components/NavigationDrawer";
import SearchInput from "@gaiaProfessionals/Widgets/HCP/Header/SearchInput";
import * as S from "@gaiaProfessionals/Widgets/HCP/Navigation/MasterNavigation.styles";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import { Dictionary } from "@insite/client-framework/Common/Types";
import Zone from "@insite/client-framework/Components/Zone";
import {
    Category,
    getCategoryById,
    GetCategoryByIdApiParameter,
} from "@insite/client-framework/Services/CategoryService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import Button from "@insite/mobius/Button";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import LogOutIcon from "@insite/mobius/Icons/LogOut";
import SearchIcon from "@insite/mobius/Icons/Search";
import CartIcon from "@insite/mobius/Icons/ShoppingCart";
import UploadIcon from "@insite/mobius/Icons/Upload";
import UserIcon from "@insite/mobius/Icons/User";
import Link from "@insite/mobius/Link";
import isEqual from "lodash/isEqual";
import { FunctionComponent, useEffect, useLayoutEffect, useRef, useState } from "react";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

/* ***  Component types/interfaces  *** */

const enum fields {
    links = "links",
    showQuickOrder = "showQuickOrder",
}

interface OwnProps extends WidgetProps {
    fields: {
        links?: any[];
        bannerMessage: string;
        logo: string;
        navigationMenus: any[];
    };
}

interface NavCartProps {
    cart: {
        shouldLoad: boolean;
        count?: number;
        url: string;
    };
}
interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        linkType: "Link" | "MegaMenu" | "CascadingMenu";
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        maxDepth: number;
        numberOfContentBlocks?: number;
        contentBlockDestination?: LinkFieldValue;
        contentBlockCopy?: string;
        contentBlockImage?: any;
        contentBlockDestination2?: LinkFieldValue;
        contentBlockCopy2?: string;
        contentBlockImage2?: any;
        contentBlockDestination3?: LinkFieldValue;
        contentBlockCopy3?: string;
        contentBlockImage3?: any;
    };
}

export interface MappedLink {
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    maxDepth?: number;
    childrenType?: "MegaMenu" | "CascadingMenu";
    children?: MappedLink[];
    linkListHeading?: string;
    contentBloackHeading?: string;
    contentBlockImage?: string;
}

interface MenuLinks {
    url: string;
    title: string;
}

interface FieldData {
    fields?: any;
}

interface TempHolder {
    icon?: string;
    type?: string;
    value?: string;
}

// Extracts nested link data for each menu
function extractLinkData(data: fields[], matchString: string[]): any {
    const result: any[] = [];

    // Recursive function to handle nested objects and arrays
    function traverse(item: any) {
        if (Array.isArray(item)) {
            for (let i = 0; i < item.length; i++) {
                traverse(item[i]);
            }
        } else if (typeof item === "object" && item !== null) {
            const temp: TempHolder = {};
            for (const key in item) {
                if (matchString.includes(key)) {
                    if (key === "linkIcon") {
                        temp.icon = item[key];
                    } else {
                        temp.type = item[key].type;
                        temp.value = item[key].value;
                    }
                }
                traverse(item[key]);
            }
            if (Object.keys(temp).length > 0) {
                result.push(temp);
            }
        }
    }

    traverse(data);
    return result;
}

function pullProps(data: FieldData[], matchArray: string[]): any {
    const result: any[] = [];

    // Recursive function to handle nested objects and arrays
    function traverse(item: any) {
        if (Array.isArray(item)) {
            for (let i = 0; i < item.length; i++) {
                traverse(item[i]);
            }
        } else if (typeof item === "object" && item !== null) {
            for (const key in item) {
                if (matchArray.includes(key)) {
                    const keyValueObj: any = {};
                    keyValueObj[key] = item[key];
                    result.push(keyValueObj);
                }
                traverse(item[key]);
            }
        }
    }

    traverse(data);
    return result;
}
// Flattens multi-dimensional array
function flatten(data: any[]): any[] {
    return data.reduce(function (flat: any, toFlatten: any) {
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
}

function cleanString(str: string): any {
    const lastSegment = str.split("/").pop();
    return lastSegment?.replace(/-/g, " ");
}

// Build callout data object from component data
function extractCalloutData(components: any, searchKeys: string[]): any[] {
    return components
        .map((c: any) => {
            const data = pullProps(c, searchKeys);
            let result;
            if (data.length > 0) {
                result = data.reduce((acc: any, callout: any) => {
                    return Object.assign(acc, callout);
                }, {});
            } else {
                result = null;
            }
            return result;
        })
        .filter(Boolean); // Filter out null values if no props are pulled
}
// Traverses component fields and extracts UI data
function extractData(components: any, searchKeys: string[]): any[] {
    return components
        .map((c: any) => {
            const data = pullProps(c, searchKeys);
            let result;
            if (data.length > 0) {
                result = data.reduce((acc: any, callout: any) => {
                    return Object.assign(acc, callout);
                }, {});
            } else {
                result = null;
            }
            return result;
        })
        .filter(Boolean);
}
// Returns boolean if object contains empty values
function isValid(arrayOfObjects: any[]): boolean {
    return arrayOfObjects.every((obj: any) => {
        return Object.values(obj).some(value => value !== null);
    });
}

function filterMenus(arrayOfObjects: any[]): any[] {
    const result: any[] = [];

    for (const obj of arrayOfObjects) {
        const newObj: any = {};
        for (const key in obj) {
            if (Array.isArray(obj[key]) && ["links", "callouts", "ctas"].includes(key)) {
                newObj[key] = obj[key].filter((innerObj: any) => innerObj.menuType === key);
            } else {
                newObj[key] = obj[key];
            }
        }
        result.push(newObj);
    }

    return result;
}

// <============== Mapping State to Props ==============>
const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    // Destructure properties from ownProps
    const {
        fields: { links = [], bannerMessage, logo, navigationMenus },
    } = ownProps;

    // Initialize array to store transformed links
    const mappedLinks = [];
    let menuData = [];

    for (const menu of navigationMenus) {
        const menuContainer: any[] = [];
        const payload: any = {};

        const {
            fields: { components, menuTitle, dropdownType },
        } = menu;

        let linkData = components.reduce((acc: any, c: any) => {
            const links = extractLinkData(c, ["linkDestination", "linkIcon"]);
            if (links.length > 0) {
                acc.push(...links);
            }
            return acc;
        }, []);

        linkData = linkData.map((link: any) => {
            const { type, value, icon } = link;
            let payload;
            if (type === "Category") {
                payload = getCategoryById({ id: value }).then(result => {
                    return {
                        url: result.path,
                        title: result.name,
                        icon,
                        menuType: "links",
                    };
                });
            } else if (type === "Page") {
                const pageLink = getPageLinkByNodeId(state, value);
                payload = {
                    url: pageLink?.url,
                    title: pageLink?.title,
                    icon,
                    menuType: "links",
                };
            } else if (type === "Url") {
                payload = {
                    url: value,
                    title: cleanString(value),
                    icon,
                    menuType: "links",
                };
            }
            return payload;
        });

        const calloutKeys = [
            "calloutDestination",
            "calloutHeading",
            "calloutImage",
            "calloutImageAlt",
            "calloutText",
            "menuType",
        ];
        const calloutDataTemp = extractData(components, calloutKeys);
        const calloutData = calloutDataTemp.map((d: any) => {
            if (d.menuType === "callouts") {
                return {
                    destination: getPageLinkByNodeId(state, d.calloutDestination.value),
                    heading: d.calloutHeading,
                    image: d.calloutImage,
                    imageAlt: d.calloutImageAlt,
                    text: d.calloutText,
                    menuType: d.menuType,
                };
            }
            return d;
        });

        const ctaKeys = [
            "ctaButtonText",
            "ctaDestination",
            "ctaHeading",
            "ctaImage",
            "ctaImageAlt",
            "ctaText",
            "menuType",
        ];
        const ctaDataTemp = extractData(components, ctaKeys);
        const ctaData = ctaDataTemp.map((cta: any) => {
            if (cta.menuType === "ctas") {
                return {
                    destination: getPageLinkByNodeId(state, cta.ctaDestination.value),
                    buttonText: cta.ctaButtonText,
                    heading: cta.ctaHeading,
                    image: cta.ctaImage,
                    imageAlt: cta.ctaImageAlt,
                    text: cta.ctaText,
                };
            }
            return cta;
        });

        const listKeys = ["listHeading", "listCtaText", "listButtonText", "listButtonDestination"];
        const listData = extractData(components, listKeys);

        // Build payload object
        if (isValid(linkData)) {
            payload.links = linkData;
        }

        if (isValid(calloutData)) {
            payload.callouts = calloutData;
        }

        payload.cta = ctaData;

        const lData = listData[0];

        payload.data = {
            buttonText: lData.listButtonText,
            heading: lData.listHeading,
            destination: lData.listButtonDestination?.value,
        };

        payload.menuTitle = menuTitle;
        payload.type = dropdownType;
        menuData.push(payload);
    }
    menuData = filterMenus(menuData);

    // Object to track which category IDs need to be loaded
    const categoryIdsToLoad: Dictionary<number> = {};

    // Retrieve additional properties from state and cookies
    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const orderSettings = getSettingsCollection(state).orderSettings;
    const session = getSession(state);
    const billToState = getBillToState(state, state.context.session.billToId);
    const cart = getCurrentCartState(state).value;
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const isGuest = session?.isGuest;
    const isPurchaser = billToState?.value?.properties?.checkoutDissabled?.toLowerCase() !== "true";
    const shouldLoadCart = !getCurrentCartState(state).value && !getCurrentCartState(state).isLoading;
    const cartCount = getCurrentCartState(state).value?.totalCountDisplay;
    const cartUrl = getPageLinkByPageType(state, "CartPage")?.url;

    const cartData = {
        shouldLoad: shouldLoadCart,
        count: cartCount,
        url: cartUrl,
    };

    // Return an object containing all the prepared data, which will be passed as props to the component
    return {
        session,
        menuData,
        // links: mappedLinks,
        bannerMessage,
        logo,
        billToState,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        isAuthenticated,
        isGuest,
        isPurchaser,
        cart: cartData,
        displayVmiNavigation:
            currentMode === "Vmi" &&
            orderSettings.vmiEnabled &&
            isAuthenticated &&
            session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1,
        displayModeSwitch:
            isAuthenticated && orderSettings.vmiEnabled && session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1,
        currentMode,
        vmiPageLinks: [
            getPageLinkByPageType(state, "VmiDashboardPage"),
            getPageLinkByPageType(state, "VmiLocationsPage"),
            getPageLinkByPageType(state, "VmiUsersPage"),
            getPageLinkByPageType(state, "VmiBinsPage"),
            getPageLinkByPageType(state, "VmiReportingPage"),
            getPageLinkByPageType(state, "VmiOrderHistoryPage"),
        ],
    };
};

// <============== Configure Categories ==============>
const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
});

const mapDispatchToProps = {
    loadCategories,
    signOut,
    loadBillTo,
};

// <============== Component ==============>
const MasterNavigationWidget: FunctionComponent<any> = props => {
    // Extract attributes from props
    const {
        id,
        session,
        links,
        isAuthenticated,
        isGuest,
        isPurchaser,
        signOut,
        billToState,
        loadBillTo,
        bannerMessage,
        logo,
        cart,
        menuData,
        displayChangeCustomerLink,
        displayVmiNavigation
    } = props


    const [mobileSearchModalIsOpen, setMobileSearchModalIsOpen] = useState(false);
    // ********** Nav Resize ********** //
    // Grabs the height of the MasterNavContentWrapper component and outputs as navHeight
    // Used to assign the height of the MasterNav component to create space between the fixed nav and page content equal to the height of the nav
    const masterNavContentWrapperRef = useRef<HTMLDivElement>(null);
    const [navHeight, setNavHeight] = useState(0);

    // ********** Account Management Menu Alignment ********** //
    // Used to align the dropdown menu to be centered based off parent element width and current menu width
    const accountMenuParentRef = useRef<HTMLLIElement>(null);
    const accountMenuRef = useRef<HTMLDivElement>(null);
    const [accountMenuParentWidth, setAccountMenuParentWidth] = useState(0);
    const [accountMenuWidth, setAccountMenuWidth] = useState(0);

    // ********** Loading Categories ********** //
    const loadCategoriesIfNeeded = (isComponentDidUpdate = false) => {
        const { categoryIdsToLoad } = props;
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = categoryIdsToLoad[categoryId];
                if (!props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    props.loadCategories(getParameter(categoryId, maxDepth));
                }
            }
        }
    };

    // ********** Search Btn Menu Toggle ********** //
    // Used to handle toggling the search menu
    const searchButtonWrapperRef = useRef<HTMLLIElement>(null);
    const searchMenuWrapperRef = useRef<HTMLDivElement>(null);
    const [searchMenuIsOpen, setSearchMenuIsOpen] = useState(false);

    const toggleSearchMenu = () => {
        if (searchMenuIsOpen === false) {
            setSearchMenuIsOpen(true);
        } else {
            setSearchMenuIsOpen(false);
        }
    };
    const handleSearchMouseLeave = () => {
        setSearchMenuIsOpen(false);
    };
    const closeSearchMenu = () => {
        setSearchMenuIsOpen(false);
    };

    // <============== Use Effects ==============>

    // ********** Set Menu Heights and Widths on Load ********** //
    useLayoutEffect(() => {
        // Sets nav size on render
        if (masterNavContentWrapperRef.current != null) {
            setNavHeight(masterNavContentWrapperRef.current.offsetHeight);
        }
        // Sets account menu width and parent width on render
        if (accountMenuParentRef.current && accountMenuRef.current != null) {
            setAccountMenuParentWidth(accountMenuParentRef.current.offsetWidth);
            setAccountMenuWidth(accountMenuRef.current.offsetWidth);
        }
    }, [
        accountMenuParentWidth,
        accountMenuWidth,
        navHeight,
        masterNavContentWrapperRef,
        accountMenuParentRef,
        accountMenuRef,
    ]);

    // ********** Adjust Master Nav Height on Window Resize ********** //
    useEffect(() => {
        loadCategoriesIfNeeded(true);
        // On Window Resize
        function onWindowResize() {
            if (masterNavContentWrapperRef.current != null) {
                // Resets the size if changed on window resize
                setNavHeight(masterNavContentWrapperRef.current.offsetHeight);
            }
        }

        // Event Listeners
        window.addEventListener("resize", onWindowResize);
        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [navHeight, masterNavContentWrapperRef]);

    // ********** Load BillTo ********** //
    useEffect(() => {
        if (!billToState.value && !billToState.isLoading && session.billToId && session.isAuthenticated) {
            loadBillTo({ billToId: session.billToId });
        }
    }, [billToState]);

    // ********** Handle Search Button Toggle ********** //
    useEffect(() => {
        // Handle Clicks
        const handleClick = (event: MouseEvent): any => {
            // On Click, if click is outside the search wrapper and the menu is open, close menu
            if (searchButtonWrapperRef.current != null) {
                if (searchButtonWrapperRef.current && !searchButtonWrapperRef.current?.contains(event.target as Node)) {
                    if (searchMenuIsOpen === true) {
                        setSearchMenuIsOpen(false);
                    }
                }
            }
        };

        // Handle KeyUps
        const onKeyUp = (event: KeyboardEvent): any => {
            if (event.key === "Escape") {
                // On Escape, if search menu is open, close menu
                if (searchMenuIsOpen === true) {
                    setSearchMenuIsOpen(false);
                    document.getElementById("navSearchMenuButton")?.focus();
                }
            }
        };

        // Event Listeners
        document.addEventListener("click", handleClick, true);
        document.addEventListener("keyup", onKeyUp, true);
        return () => {
            document.removeEventListener("click", handleClick, true);
            document.removeEventListener("keyup", onKeyUp, true);
        };
    }, [searchMenuIsOpen, searchButtonWrapperRef]);

    const quickPageMockData = {
        title: "My Title Child",
        url: "http://mytitlechild.com",
        id: "quickorderID",
    };

    const accountData = {
        accountMenuWidth,
        accountMenuParentWidth,
        accountMenuRef,
        accountMenuParentRef,
        isAuthenticated,
        isGuest,
        isPurchaser,
        signOut,
    };

    const mobileLinks: any[] = [];

    // Build mobile link data structure
    for (const menu of menuData) {
        const link: any = {};
        link.title = menu.menuTitle;
        if (menu.links.length > 0) {
            link.children = [...menu.links];
        }
        mobileLinks.push(link);
    }

    // <============== Component Render ==============>
    return (
        <S.MasterNav 
            style={{ height: `${navHeight}px` }}
        >
            <S.MasterNavContentWrapper ref={masterNavContentWrapperRef}>
                {/* TopNav Navigation START */}
                <S.TopNav>
                    <span>{bannerMessage}</span>
                </S.TopNav>
                {/* TopNav Navigation END */}

                {/* Main Navigation START */}
                <S.MainNav aria-label="Main">
                    <NavigationDrawer
                        links={mobileLinks}
                        showQuickOrder={false}
                        quickOrderLink={quickPageMockData}
                        displayVmiNavigation={displayVmiNavigation}
                        // displayChangeCustomerLink={displayChangeCustomerLink}
                        // displayModeSwitch={displayModeSwitch}
                        // currentMode={currentMode}
                        // isCompactHeaderFlyout={true}
                        // showSignOutOnly={showSignOutOnly}
                    />
                    <S.LogoBlock>
                        <a className="logoBlock__link" href="/">
                            <img src={logo} alt="Gaia Herbs company logo" />
                        </a>
                    </S.LogoBlock>
                    <S.LinkBlock>
                        <S.NavLinkList>
                            {menuData.map((menu: any, index: any) => (
                                <NavLinkList key={index} menu={menu} isLoggedIn={isAuthenticated} />
                            ))}
                        </S.NavLinkList>
                    </S.LinkBlock>
                    <S.IconBlock>
                        <ul className="iconBlock__list">
                            <li className="iconBlock__item iconBlock__item--search" ref={searchButtonWrapperRef}>
                                <Button
                                    id="navSearchMenuButton"
                                    className="iconBlock__iconWrap iconButton search__btn"
                                    aria-expanded={searchMenuIsOpen}
                                    onClick={toggleSearchMenu}
                                >
                                    <Icon
                                        className="iconBlock__icon iconBlock__icon--search"
                                        src={SearchIcon}
                                        aria-hidden="true"
                                    ></Icon>
                                    <span className="sr-only">Search</span>
                                </Button>
                                <S.NavDropDown
                                    as="div"
                                    className="dropdown dropdown--megaMenu dropdown--search"
                                    ref={searchMenuWrapperRef}
                                >
                                    <S.MegaMenu>
                                        <div className="megaMenu__container">
                                            <div className="megaMenu__column megaMenu__column--search navSearch">
                                                <SearchInput
                                                    id="MasterNavId"
                                                    isAnimated={false}
                                                    closeSearchMenu={closeSearchMenu}
                                                />
                                            </div>
                                        </div>
                                    </S.MegaMenu>
                                </S.NavDropDown>
                            </li>
                            {!isAuthenticated && <NavSignIn account={accountData} />}
                            {isAuthenticated && <NavAccount account={accountData} />}
                            {/* {isAuthenticated && isPurchaser && <NavCart cart={cart} />} */}
                            {isAuthenticated && isPurchaser && (
                                <li className="icon_cart">
                                    <Zone contentId={id} zoneName="Content"></Zone>
                                </li>
                            )}
                        </ul>
                    </S.IconBlock>
                </S.MainNav>
                {/* Main Navigation END */}
            </S.MasterNavContentWrapper>
        </S.MasterNav>
    );
};

// <============== CMS widget information ==============>
const MasterNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MasterNavigationWidget),
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        displayName: "HCP Master Navigation",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: "navigationMenus",
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    return item.fields.menuTitle;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "menuTitle",
                        editorTemplate: "TextField",
                        isRequired: true,
                        defaultValue: "",
                        isVisible: item => true,
                    },
                    {
                        name: "dropdownType",
                        editorTemplate: "RadioButtonsField",
                        isRequired: true,
                        defaultValue: "",
                        options: [
                            {
                                displayName: "Only Links",
                                value: "links",
                            },
                            {
                                displayName: "Links and CTA",
                                value: "cta",
                            },
                            {
                                displayName: "Links and Callouts",
                                value: "callouts",
                            },
                        ],
                        isVisible: item => true,
                    },
                    {
                        name: "components",
                        editorTemplate: "ListField",
                        onEditRow: (index: number, dispatch) => {
                            dispatch({
                                type: "SendToSite/OpenMainNavigation",
                                index,
                            });
                        },
                        onDoneEditingRow: dispatch => {
                            dispatch({
                                type: "SendToSite/CloseMainNavigation",
                            });
                        },
                        onLoad: dispatch => {
                            dispatch({
                                type: "SendToSite/CloseMainNavigation",
                            });
                        },
                        getDisplay: (item: HasFields, state) => {
                            return item.fields.menuType;
                        },
                        defaultValue: [],
                        // fieldType: "Translatable",
                        fieldDefinitions: [
                            {
                                name: "menuType",
                                editorTemplate: "RadioButtonsField",
                                isRequired: true,
                                defaultValue: "",
                                options: [
                                    {
                                        displayName: "Link List",
                                        value: "links",
                                    },
                                    {
                                        displayName: "Callout",
                                        value: "callouts",
                                    },
                                    {
                                        displayName: "Call To Action",
                                        value: "ctas",
                                    },
                                ],
                            },
                            {
                                name: "linksCtaButton",
                                editorTemplate: "TextField",
                                defaultValue: "Learn More",
                                isRequired: false,
                                isVisible: item => item.fields.menutype === "links",
                            },
                            {
                                name: "listHeading",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: true,
                                isVisible: item => item.fields.menuType === "links",
                            },
                            {
                                name: "menuLinks",
                                editorTemplate: "ListField",
                                onEditRow: (index: number, dispatch) => {
                                    dispatch({
                                        type: "SendToSite/OpenMainNavigation",
                                        index,
                                    });
                                },
                                onDoneEditingRow: dispatch => {
                                    dispatch({
                                        type: "SendToSite/CloseMainNavigation",
                                    });
                                },
                                onLoad: dispatch => {
                                    dispatch({
                                        type: "SendToSite/CloseMainNavigation",
                                    });
                                },
                                getDisplay: (item: HasFields, state) => {
                                    const { type, value } = item.fields.linkDestination;
                                    let page;
                                    switch (type) {
                                        case "Url":
                                            return cleanString(value);
                                        case "Page":
                                            page = getPageLinkByNodeId(state, value);
                                            return page?.title;
                                    }
                                },
                                defaultValue: [],
                                isVisible: item => item.fields.menuType === "links",
                                fieldDefinitions: [
                                    {
                                        name: "linkDestination",
                                        editorTemplate: "LinkField",
                                        defaultValue: {
                                            value: "",
                                            type: "Page",
                                        },
                                        isRequired: true,
                                        isVisible: item => true,
                                        allowUrls: item => true,
                                        showCategoryRoot: item => true,
                                    },
                                    {
                                        name: "linkIcon",
                                        editorTemplate: "ImagePickerField",
                                        defaultValue: "",
                                        isVisible: item => true,
                                    },
                                ],
                            },
                            {
                                name: "listButtonText",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: false,
                                isVisible: item => item.fields.menuType === "links",
                            },
                            {
                                name: "listButtonDestination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Page",
                                },
                                isRequired: false,
                                isVisible: item => item.fields.menuType === "links",
                                allowUrls: item => true,
                            },
                            {
                                name: "calloutImage",
                                editorTemplate: "ImagePickerField",
                                defaultValue: "",
                                isVisible: item => item.fields.menuType === "callouts",
                            },
                            {
                                name: "calloutImageAlt",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: false,
                                isVisible: item => item.fields.menuType === "callouts",
                            },
                            {
                                name: "calloutHeading",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: false,
                                isVisible: item => item.fields.menuType === "callouts",
                            },
                            {
                                name: "calloutText",
                                editorTemplate: "MultilineTextField",
                                isRequired: true,
                                defaultValue: "",
                                isVisible: item => item.fields.menuType === "callouts",
                            },
                            {
                                name: "calloutDestination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Page",
                                },
                                isRequired: true,
                                isVisible: item => item.fields.menuType === "callouts",
                            },
                            {
                                name: "ctaImage",
                                editorTemplate: "ImagePickerField",
                                defaultValue: "",
                                isVisible: item => item.fields.menuType === "ctas",
                            },
                            {
                                name: "ctaImageAlt",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: false,
                                isVisible: item => item.fields.menuType === "ctas",
                            },
                            {
                                name: "ctaHeading",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: true,
                                isVisible: item => item.fields.menuType === "ctas",
                            },
                            {
                                name: "ctaText",
                                editorTemplate: "MultilineTextField",
                                isRequired: true,
                                defaultValue: "",
                                isVisible: item => item.fields.menuType === "ctas",
                            },
                            {
                                name: "ctaDestination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Page",
                                },
                                isRequired: true,
                                isVisible: item => item.fields.menuType === "ctas",
                            },
                            {
                                name: "ctaButtonText",
                                editorTemplate: "TextField",
                                isRequired: true,
                                defaultValue: "",
                                isVisible: item => item.fields.menuType === "ctas",
                            },
                        ],
                    },
                ],
            },
            {
                name: "bannerMessage",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: "logo",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default MasterNavigation;
